import {
  APIHOSTVISUALIZE,
  BPIAM_API,
  KNOWLEDGE,
  KNOWLEDGE_API,
  MARKETING_API,
  OSS_API,
} from '@/constants/API';
import { request } from '@umijs/max';

// 社媒分析
export async function assistantIdSocialMedia({
  assistantId,
}: {
  assistantId: string | undefined;
  state?: string | number;
}) {
  return request(`${MARKETING_API}/assistant/analysis/social_media/${assistantId}`, {
    method: 'get',
  });
}
// 数据分析
export async function getAssistantData(params: any) {
  return request(`${MARKETING_API}/assistant/analysis/data`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 获取品牌列表
export async function serBrandList({
  assistantId,
  state = '',
}: {
  assistantId: string | undefined;
  state?: string | number;
}) {
  return request(`${MARKETING_API}/brand/list/${assistantId}?state=${state}`, {
    method: 'get',
  });
}